// Angular Files
import {
 Component, NgModule, Input, AfterContentInit, HostBinding, HostListener, ElementRef
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { A11yModule } from '@angular/cdk/a11y';

// Angular Material Files
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

// Teller Online Library Files
import { TellerOnlineIconsModule } from 'teller-online-libraries/icons';

@Component({
    selector: 'teller-online-fab-menu',
    templateUrl: './fab-menu.component.html',
    styleUrls: ['./fab-menu.component.scss'],
    host: {
        class: 'fab-menu'
    },
    standalone: false
})
export class TellerOnlineFabMenuComponent implements AfterContentInit {
    // Declare @Input variables
    @Input() actionButtons: TellerOnlineFabMenuActionItem[];

    @Input() icon?: string;

    @Input() color?: string = 'accent';

    /** If provided, the fab will be an extended fab with this text */
    @Input() extended?: string;

    /** If true, will only be extended when it's active */
    @Input() extendOnActive: boolean = false;

    // Declare @Output variables

    // Public variables
    public FabMenuActionType = TellerOnlineFabMenuActionType;

    // Private variables

    // Subscriptions

    @HostBinding('class.fab-menu--active') public isActive = false;

    @HostListener('document:keydown', ['$event'])
    onKeydown(e) {
        if (e.key == 'Escape') this.isActive = false;
    }

    constructor(private el: ElementRef) {}

    ngAfterContentInit() {
    }

    public onClick_toggleMenu() {
        this.isActive = !this.isActive;
        // push off the event to make sure the change is rendered first
        // then focus the first focusable element
        setTimeout(() => {
            this.el.nativeElement.querySelector('.fab-menu__actions').querySelector('button, a').focus();
        }, 0);
    }
}
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        A11yModule,
        TellerOnlineIconsModule
    ],
    declarations: [TellerOnlineFabMenuComponent],
    exports: [TellerOnlineFabMenuComponent]
})
export class TellerOnlineFabMenuModule { }

export class TellerOnlineFabMenuActionItem {
    icon?: string;

    color?: string = 'accent';

    actionType: TellerOnlineFabMenuActionType = TellerOnlineFabMenuActionType.Button;

    action: string | Function;

    /**
     * If provided, will appear as a white box to the left of the fab button matching material design spec
     */
    label?: string;
}

export enum TellerOnlineFabMenuActionType {
    /** Will be rendered as an anchor tag for proper accessibility
     * Clicking it will take the user to another page
    */
    Anchor,
    /** Will be rendered as a button tag for proper accessibility
     * Clicking it will perform an action on this page
    */
    Button
}
